<div class="form-container">
  <div class="form-card">
    <form (ngSubmit)="nextPage()" autocomplete="off" class="vertical-form" novalidate>
      <h3 class="mb-2 fs-5">Club Information</h3>
      <p class="text-secondary mb-4 fs-6">Please provide the details below to register your club admin account.</p>

      <!-- Club Name -->
      <div class="field mb-4">
        <label for="clubName" class="form-label">Club Name <span aria-hidden="true">*</span></label>
        <input pInputText id="clubName" name="clubName"
          [(ngModel)]="adminInformation.clubName"
          [class.ng-invalid]="submitted() && !adminInformation.clubName?.trim()"
          class="w-full" aria-required="true" autocomplete="organization"
          [attr.aria-invalid]="submitted() && !adminInformation.clubName?.trim() ? true : null"
          [attr.aria-describedby]="submitted() && !adminInformation.clubName?.trim() ? 'clubName-error' : null" />
        @if (submitted() && !adminInformation.clubName?.trim()) {
          <small id="clubName-error" role="alert" class="p-error">Club Name is required.</small>
        }
      </div>

      <!-- Primary Activity -->
      <div class="field mb-4">
        <label for="primaryActivitySelect" class="form-label">Primary Activity <span aria-hidden="true">*</span></label>
        <p-select id="primaryActivity" inputId="primaryActivitySelect" name="primaryActivity"
          [(ngModel)]="adminInformation.primaryActivity"
          [options]="activities()" optionLabel="ActivityName" optionValue="ActivityCode"
          placeholder="Select Primary Activity"
          [class.ng-invalid]="submitted() && !adminInformation.primaryActivity"
          ariaLabel="Primary Activity" panelStyleClass="comp-dark-panel"
          class="w-full" aria-required="true" />
        @if (submitted() && !adminInformation.primaryActivity) {
          <small id="primaryActivity-error" role="alert" class="p-error">Primary Activity is required.</small>
        }
      </div>

      <h3 class="mb-2 mt-4 fs-5">Contact Information</h3>
      <p class="text-secondary mb-4 fs-6">Please provide the contact details for the primary administrator.</p>

      <!-- Contact Person -->
      <div class="field mb-4">
        <label for="contactPerson" class="form-label">Contact Person <span aria-hidden="true">*</span></label>
        <input pInputText id="contactPerson" name="contactPerson"
          [(ngModel)]="adminInformation.contactPersonName"
          [class.ng-invalid]="submitted() && !adminInformation.contactPersonName?.trim()"
          class="w-full" aria-required="true" autocomplete="name"
          [attr.aria-invalid]="submitted() && !adminInformation.contactPersonName?.trim() ? true : null"
          [attr.aria-describedby]="submitted() && !adminInformation.contactPersonName?.trim() ? 'contactPerson-error' : null" />
        @if (submitted() && !adminInformation.contactPersonName?.trim()) {
          <small id="contactPerson-error" role="alert" class="p-error">Contact Person is required.</small>
        }
      </div>

      <!-- Phone Number -->
      <div class="field mb-4">
        <label for="phoneNumber" class="form-label">Phone Number <span aria-hidden="true">*</span></label>
        <input pInputText id="phoneNumber" name="phoneNumber" type="tel"
          [(ngModel)]="adminInformation.phoneNumber"
          [class.ng-invalid]="submitted() && (!adminInformation.phoneNumber || !isValidPhone(adminInformation.phoneNumber))"
          (keypress)="$event.key === '+' || $event.key >= '0' && $event.key <= '9' || $event.preventDefault()"
          (paste)="onPhonePaste($event)"
          class="w-full" aria-required="true" autocomplete="tel"
          [attr.aria-invalid]="submitted() && (!adminInformation.phoneNumber || !isValidPhone(adminInformation.phoneNumber)) ? true : null"
          [attr.aria-describedby]="submitted() && (!adminInformation.phoneNumber || !isValidPhone(adminInformation.phoneNumber)) ? 'phoneNumber-error' : null" />
        @if (submitted() && !adminInformation.phoneNumber) {
          <small id="phoneNumber-error" role="alert" class="p-error">Phone Number is required.</small>
        } @else if (submitted() && !isValidPhone(adminInformation.phoneNumber)) {
          <small id="phoneNumber-error" role="alert" class="p-error">Enter a valid phone number (7-15 digits).</small>
        }
      </div>

      <!-- Admin Email -->
      <div class="field mb-4">
        <label for="adminEmail" class="form-label">Club Admin Email ID <span aria-hidden="true">*</span></label>
        <input pInputText id="adminEmail" name="adminEmail" type="email"
          [(ngModel)]="adminInformation.email"
          [class.ng-invalid]="submitted() && (!adminInformation.email?.trim() || !isValidEmailFormat(adminInformation.email))"
          class="w-full" aria-required="true" autocomplete="off"
          [attr.aria-invalid]="submitted() && (!adminInformation.email?.trim() || !isValidEmailFormat(adminInformation.email)) ? true : null"
          [attr.aria-describedby]="submitted() && (!adminInformation.email?.trim() || !isValidEmailFormat(adminInformation.email)) ? 'adminEmail-error' : null" />
        @if (submitted() && !adminInformation.email?.trim()) {
          <small id="adminEmail-error" role="alert" class="p-error">Admin Email is required.</small>
        } @else if (submitted() && !isValidEmailFormat(adminInformation.email)) {
          <small id="adminEmail-error" role="alert" class="p-error">Enter a valid email address.</small>
        }
      </div>

      <!-- Password -->
      <div class="field mb-5">
        <label for="adminPasswordInput" class="form-label">Password <span aria-hidden="true">*</span></label>
        <p-password id="adminPassword" inputId="adminPasswordInput" name="adminPassword"
          [(ngModel)]="adminInformation.password"
          [class.ng-invalid]="submitted() && (!adminInformation.password?.trim() || adminInformation.password.length < 6)"
          [feedback]="false" [toggleMask]="true"
          inputStyleClass="w-full" styleClass="w-full"
          aria-required="true" autocomplete="new-password" />
        @if (submitted() && !adminInformation.password?.trim()) {
          <small id="adminPassword-error" role="alert" class="p-error">Password is required.</small>
        } @else if (submitted() && adminInformation.password.length < 6) {
          <small id="adminPassword-error" role="alert" class="p-error">Password must be at least 6 characters long.</small>
        }
      </div>

      <div class="field mt-5">
        <app-button type="submit" label="Save and Next" variant="filled" color="primary" [fullWidth]="true"
          class="w-100 d-block">
        </app-button>
      </div>
    </form>
  </div>
</div>
